// Mirrors backend/src/lib/tripLifecycle.js. A trip's lifecycle is derived from
// cancelledAt + its dates, never stored:
//   cancelledAt != null             → CANCELLED
//   endDate < today                  → COMPLETED
//   startDate <= today <= endDate    → ONGOING
//   otherwise (future / no dates)    → UPCOMING
// A missing endDate falls back to startDate (single-day trip).
export const DAY_MS = 24 * 60 * 60 * 1000;

export function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

// `status === 'CANCELLED'` covers rows cancelled before cancelledAt existed.
export const isCancelled = (trip) => !!trip && (trip.cancelledAt != null || trip.status === 'CANCELLED');

export function tripLifecycle(trip, now = new Date()) {
  if (!trip) return 'UPCOMING';
  if (isCancelled(trip)) return 'CANCELLED';
  const today = startOfDay(now);
  const start = trip.startDate ? startOfDay(trip.startDate) : null;
  const end = trip.endDate ? startOfDay(trip.endDate) : null;
  const last = end || start;
  if (last && last < today) return 'COMPLETED';
  if (start && start <= today) return 'ONGOING';
  return 'UPCOMING';
}

export const isCompleted = (trip, now) => tripLifecycle(trip, now) === 'COMPLETED';
